<template>

  <t-page>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template #default="{status}">

        <t-input v-model="form.scheduleId" hidden/>

        <t-input-code-label enterprise
                            enable-import-model
                            @change="getModelsByEnterpriseId"
                            :status="status"
                            :command="command"
                            required
                            :add-error="error.enterpriseId"
                            v-model="form.enterpriseId"/>


        <t-input v-show="form.enterpriseId > 0" select :options="typeChecklistOptions" v-model="form.typeChecklistId"
                 label="Modelo de Inspeção"
                 required/>

        <t-input v-model="form.subject" label="Assunto"/>


        <t-input v-model="form.note" label="Observações" max-length="2000" textarea/>


        <b-form-checkbox class="col-sm-12 ml-2 mb-3 mt-3" v-model="form.sharing" switch>
          Compartilhar para um grupo de usuários?
          <t-help
              title="Você poderá especificar um inspetor exclusivo, basta desmarcar esta opção."/>
        </b-form-checkbox>


        <t-input select :options="groupUserOptions" v-show="form.sharing" v-model="form.groupUserId"
                 label="Grupo de Usuário" :required="form.sharing"/>


        <t-input select :options="inspectorOptions" v-show="!form.sharing" v-model="form.inspectorId"
                 label="Inspetor exclusivo" :required="!form.sharing"/>


        <b-row>

          <t-input date v-model="form.startDate"
                   cols="3"
                   required
                   label="Data inicial"/>

          <t-input time v-model="form.startTime"
                   cols="3"
                   label="Horário inicial"/>

          <t-input date v-model="form.finishDate"
                   cols="3"
                   required
                   label="Data final"/>

          <t-input time v-model="form.finishTime"
                   cols="3"
                   label="Horário final"/>

        </b-row>


        <b-row v-if="form.statusSchedule === ScheduleStatusType.type.DONE">

          Informações da Agenda finalizada em desenvolvimento!

        </b-row>


      </template>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import TypeChecklistModelService from "@/services/modules/checklist/TypeChecklistModel.service";
import InspectorService from "@/services/modules/agent/Inspector.service";
import GroupUserService from "@/services/modules/admin/GroupUser.service";
import ScheduleStatusType from "@/model/types/modules/checklist/ScheduleStatusType";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'ScheduleForm',
  data() {
    return {
      ScheduleStatusType,
      path: "", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: false,
      fieldKey: "scheduleId",
      form: {
        scheduleId: 0,
        scheduleNumber: 0,
        enterpriseId: 0,
        sharing: false,
        subject: "",
        note: "",
        startDate: "",
        startTime: "10:20:00",
        finishDate: "",
        finishTime: "",
        typeChecklistId: 0,
        inspectorId: 0,
        groupUserId: 0,
        typeChecklist: "",
        statusSchedule: 0,
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
        enterpriseId: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      typeChecklistOptions: [],
      inspectorOptions: [],
      groupUserOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {


      await InspectorService.selectList("").then((list) => {
        this.inspectorOptions = list
      }).catch(error => this.responseError(error))

      await GroupUserService.selectList("").then((list) => {
        this.groupUserOptions = list
      }).catch(error => this.responseError(error))

      if (this.isInsert()) {

        let inspectorId = this.getRenderRule('inspector-by-user')

        if (this.objValid(inspectorId))
          this.form.inspectorId = inspectorId

      }

      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    async getModelsByEnterpriseId() {

      if (this.form.enterpriseId > 0) {

        await TypeChecklistModelService.getModelsByEnterpriseId(this.form.enterpriseId).then((list) => {
          this.typeChecklistOptions = list
        }).catch(error => this.responseError(error))

      }

    }

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  }

}
</script>

